import {React, useState} from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

import { raiseToast } from "../../../../services/redux/reducers/toast/toast";

import { getBuyerProductName, getBuyerProductSpecification, getProductQty, numberConversion } from "../../../../utils";
import { Button } from "../../../../helpers";
import { getDocCopyByDocNo } from "../../../../services/api/docCopy";
import downloadFile from "../../../../utils/DownloadFile";
import { getPMCompanyConfig } from "../../../../setup/pmCompanyConfig";
import CopyToClipboard from "../../../../common/CopyToClipboard";


const BuyerInvoiceModalData = (props) => {
    const { buyerInvoice, buyerInvoiceItems, materialDetails, setIsPageLoading } = props

    const navigate = useNavigate()
    const dispatch = useDispatch()

    const pmCompanyConfig = getPMCompanyConfig(buyerInvoice.pmCompanyId)
    let { currencyShortName, numberLocale } = pmCompanyConfig
   
    const viewBuyerInvoicePDF = async () => {
        setIsPageLoading(true)
        const docCopyRes = await getDocCopyByDocNo(buyerInvoice.docNo, true)
        if (docCopyRes?.failure){
            return dispatch(raiseToast({ severity: 'error', detail: docCopyRes?.data?.error }))
        }
        setIsPageLoading(false)
        window.open(docCopyRes.docLocation, "_blank");
    }

    const downloadBuyerInvoicePDF = async () => {
        setIsPageLoading(true)
        const docCopyRes = await getDocCopyByDocNo(buyerInvoice.docNo, true)
        if (docCopyRes?.failure){
            return dispatch(raiseToast({ severity: 'error', detail: docCopyRes?.data?.error }))
        }
        setIsPageLoading(false)
        downloadFile(docCopyRes.docLocation, `Invoice-${buyerInvoice.docNo}.pdf`)
    }

    return (
        <div className={`p-card my-2 py-2 buyerpo-modal-data ${buyerInvoice?.statusId === 6 ? 'cancelled-watermark' : ''}`}>
            {/* <ConfirmPopup /> */}
            <div className="grid">
                <div className="flex flex-row col-12 justify-content-between pb-0">
                    <div className="flex flex-row justify-content-start align-items-center col-12 md:col-4 lg:col-4 lg:mb-0 pl-0">
                        <h5 className="m-0 quote-number doc-no-navigation"> <span style={{ fontWeight: "lighter" }}>Invoice No:</span> <span className="">{buyerInvoice?.docNo}</span></h5>
                        {
                            buyerInvoice?.docNo ? <CopyToClipboard text={buyerInvoice?.docNo} /> : ""
                        }
                    </div>
                    <div className="flex flex-row col-12 mb-2 md:col-4 lg:col-4 lg:mb-0 justify-content-center">
                        <div><span>Total Price:</span>&nbsp;<span className="price-value font-semibold">{numberConversion(parseFloat(buyerInvoice?.totalAmountWithTax), numberLocale)}</span></div>
                    </div>
                    <div className="flex flex-row col-12 mb-2  md:col-4 lg:col-4 lg:mb-0 align-items-center justify-content-end pt-0">
                        <Button severity="success" rounded onClick={viewBuyerInvoicePDF}>
                            <i className="pi pi-eye" style={{ fontSize: "0.9rem" }} />
                        </Button>
                        <Button className="bg-blue-300 border-blue-300" severity="success ml-2" rounded onClick={downloadBuyerInvoicePDF}>
                            <i className="pi pi-download" style={{ fontSize: "0.9rem" }} />
                        </Button>
                    </div>
                </div>
            </div>
            <div className="dialog-table-container">
                <table className="dialog-table" style={{ width: "100%" }}>
                    <thead >
                        <tr className="">
                            <th className="" style={{ width: "5%"}}>SR</th>
                            <th className="" style={{ width: "20%"}}>PRODUCT</th>
                            <th className="" style={{ width: "35%"}}>SPECIFICATION</th>
                            <th className="" style={{ width: "10%"}}>QUANTITY</th>
                            <th className="" style={{ width: "10%"}}>UNITPRICE</th>
                            <th className="" style={{ width: "10%"}}>GSTRATE</th>
                            <th className="" style={{ width: "10%"}}>AMOUNT</th>
                        </tr>
                    </thead>
                    <tbody style={{ fontSize: "12px", borderCollapse: "collapse" }}>
                        {
                            buyerInvoiceItems?.map((eachBuyerInvoiceItem, index) => {
                                const relatedMaterial = materialDetails?.find(eachMaterial => eachMaterial?.materialId === eachBuyerInvoiceItem?.materialId)
                                return (
                                    <tr key={`buyerInvoiceItem-${eachBuyerInvoiceItem.buyerInvoiceItemId}`} className="" style={{ borderBottom: "1px solid #818181", borderCollapse: "collapse" }}>
                                        <td className="" style={{ width: "5%"}}>{index + 1}</td>
                                        <td className="" style={{ width: "20%"}}>{getBuyerProductName(relatedMaterial.companyProdName, relatedMaterial.productName)}</td>
                                        <td className="specification-column" style={{ width: "35%"}}>{getBuyerProductSpecification(relatedMaterial?.companyProdSpec, relatedMaterial?.productSpecification, relatedMaterial.UOM, relatedMaterial.UOMValue)}</td>
                                        <td className="" style={{ width: "10%"}}>{getProductQty(eachBuyerInvoiceItem?.qty, relatedMaterial.UOM, relatedMaterial.UOMValue)}</td>
                                        <td className="" style={{ width: "10%"}}>{currencyShortName}.{numberConversion(eachBuyerInvoiceItem?.unitPrice, numberLocale)}</td>
                                        <td className="" style={{ width: "10%"}}>{eachBuyerInvoiceItem?.GSTRate}%</td>
                                        <td className="" style={{ width: "10%"}}>{numberConversion(eachBuyerInvoiceItem?.itemAmountWithTax, numberLocale)}</td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default BuyerInvoiceModalData;